import { apiGet, apiPatch, apiPost } from './client';
import type { Classification, GatedResource, GatedResourceDetail, PaginatedResponse, Sensitivity } from '@/types/gated-resource';

export interface DataCatalogFilters {
  classification?: string;
  sensitivity?: string;
  domain?: string;
  label?: string;
  source_connector_id?: string;
  page?: number;
  per_page?: number;
}

export function getDataCatalog(filters?: DataCatalogFilters): Promise<PaginatedResponse<GatedResource>> {
  return apiGet<PaginatedResponse<GatedResource>>('/data-catalog', filters as Record<string, string | number | undefined>);
}

export function getDataCatalogItem(id: string): Promise<GatedResourceDetail> {
  return apiGet<GatedResourceDetail>(`/data-catalog/${id}`);
}

export function updateDataCatalogItem(id: string, data: Partial<Pick<GatedResource, 'classification' | 'sensitivity' | 'labels'>>): Promise<GatedResource> {
  return apiPatch<GatedResource>(`/data-catalog/${id}`, data);
}

/**
 * Selection is EITHER an explicit `resource_ids` list OR a `source_connector_id`
 * (classifies every resource under that connector, org-wide, not just the current
 * page). At least one selector and at least one field must be provided.
 */
export interface BulkClassifyRequest {
  resource_ids?: string[];
  source_connector_id?: string;
  classification?: Classification;
  sensitivity?: Sensitivity;
  domain?: string;
  labels?: string[];
}

export interface BulkClassifyResponse {
  updated: number;
}

export function bulkClassify(body: BulkClassifyRequest): Promise<BulkClassifyResponse> {
  return apiPost<BulkClassifyResponse>('/v1/resources/bulk-classify', body);
}
